import * as React from 'react'
import { Link } from 'react-router-dom'

import { Box, Button, useToggle } from '@factorialco/deprecated-design-system'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import { ToggleArchiveStatus } from './archiveReview'
import { DeleteReviewModal } from './modals/DeleteReviewModal'
import { DuplicateReviewModal } from './modals/DuplicateReviewModal'
import { Review } from './types'

export const Actions: React.FC<{ review: Review; canCreateReview?: boolean }> = ({
  review,
  canCreateReview,
}) => {
  const canEdit = review._policies?.manage.can
  const showPopOverMenu = canEdit || canCreateReview

  const [showDestroyModal, toggleDestroyModal] = useToggle()
  const [showDuplicateModal, toggleDuplicateModal] = useToggle()

  const { navigation } = useNavigation()

  return (
    <Box flexDirection="row" gap="s8" justifyContent="flexEnd">
      {showPopOverMenu && (
        <Box flexDirection="row" justifyContent="flexEnd" alignItems="center" gap="s8">
          <PopoverMenu type="list">
            <PopoverMenu.Trigger>
              <Button.Decorative type="secondary" iconName="ellipsis" />
            </PopoverMenu.Trigger>
            <PopoverMenu.Content side="bottom" align="start">
              {canCreateReview && (
                <PopoverMenu.TouchableOption
                  title={i18n.t('performance_process.reviews.duplicate_review.duplicate')}
                  onClick={toggleDuplicateModal(true)}
                />
              )}
              {canEdit && (
                <>
                  <ToggleArchiveStatus review={review} />
                  <PopoverMenu.TouchableOption
                    danger
                    title={i18n.t('performance_process.reviews.delete_review.delete')}
                    onClick={toggleDestroyModal(true)}
                  />
                </>
              )}
            </PopoverMenu.Content>
          </PopoverMenu>
        </Box>
      )}
      <Link to={navigation.performanceProcess.reviews.review.fullPath({ reviewId: review.id })}>
        <Button type="secondary" aria-label="Access review" iconName="arrow-right" />
      </Link>
      {showDestroyModal && (
        <DeleteReviewModal review={review} onClose={toggleDestroyModal(false)} />
      )}
      {showDuplicateModal && (
        <DuplicateReviewModal reviewId={review.id} onClose={toggleDuplicateModal(false)} />
      )}
    </Box>
  )
}
